export class ApproveOrdersCommand {
    public orderIds : string[] = [];

    constructor(orders : string[]) {
        this.orderIds = orders;
    }
}